import { createAction } from './utils';
import keyMirror from 'react-utils/keyMirror';
import { createRequestTypes, createRequestActions, createRequestStatusMeta } from 'settings-ui-lib/utils/actions';
import RequestStatusTypes from '../constants/RequestStatusTypes';
export const StagingActionTypes = keyMirror({
  SAVE_STAGED_CHANGES: null,
  STAGE_CHANGE: null,
  CLEAR_CHANGE: null,
  CLEAR_ALL: null
});
export const stageChange = (changeKey, data) => createAction(StagingActionTypes.STAGE_CHANGE, {
  changeKey,
  data
});
export const clearChange = changeKey => createAction(StagingActionTypes.CLEAR_CHANGE, {
  changeKey
});
export const clearAllChanges = () => createAction(StagingActionTypes.CLEAR_ALL);
export const SaveStagedChangesRequestTypes = createRequestTypes(StagingActionTypes.SAVE_STAGED_CHANGES);
export const SaveStagedChanges = createRequestActions(SaveStagedChangesRequestTypes, {
  // @ts-expect-error ts-migrate(2322) FIXME: Type '({ refresh }: { refresh: any; }) => { refres... Remove this comment to see the full error message
  successMetaCreator: ({
    refresh
  }) => {
    return Object.assign({}, createRequestStatusMeta(SaveStagedChangesRequestTypes.base, RequestStatusTypes.SUCCEEDED), {
      refresh
    });
  },
  // @ts-expect-error ts-migrate(2322) FIXME: Type '() => { request: { key: string; status: "UNI... Remove this comment to see the full error message
  failureMetaCreator: () => {
    return Object.assign({}, createRequestStatusMeta(SaveStagedChangesRequestTypes.base, RequestStatusTypes.FAILED));
  }
});
export const saveStagedChanges = () => createAction(StagingActionTypes.SAVE_STAGED_CHANGES);